/**
 * Created by Ning Jiang on 2021-05-03.
 */
import {NolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {IFadeTrackConf, IPlayTrackConf} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {gsap} from "gsap";
import {RockBottomGameMode} from "../server/RockBottomGameMode";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class RockBottomSound {
    public static AS_WIN:string="asWin";
    public static AS_WIN_BIG:string="asWinBig";

    public static REELS_SPINNING: string = "reelsSpinning";
    public static REELS_LANDING: string = "reelLanding1";
    public static MAIN_GAME_MUSIC: string = "background-music-main";

    public static WIN_TINY_SOUND: string = "winTiny";
    public static WIN_SMALL_SOUND: string = "winSmall";
    public static WIN_LARGE_COUNTUP: string = "winLargeCountUp";
    public static WIN_LARGE_ENDING: string = "winLargeEnd";
    public static WIN_MEDIUM_COUNTUP: string = "winMediumCountUp";
    public static WIN_MEDIUM_ENDING: string = "winMediumEnd";
    public static FREESPIN_INTRO_MUSIC: string = "fsIntroLoop";
    public static SUPER_FREESPIN_INTRO_MUSIC: string = "sfsIntroLoop";
    public static FREESPIN_MUSIC_LEVEL: string[] = ["fsLoopLevel1", "fsLoopLevel2", "fsLoopLevel3", "fsLoopLevel4", "fsLoopLevel5"];
    public static SUPER_FREESPIN_MUSIC_LEVEL: string[] = ["sfsLoopLevel1", "sfsLoopLevel2", "sfsLoopLevel3", "sfsLoopLevel4", "sfsLoopLevel5"];
    public static FREESPIN_ENDING_MUSIC: string = "fsEnd";
    public static SUPER_FREESPIN_ENDING_MUSIC: string = "sfsEnd";
    public static CONTINUE_BUTTON_BONUS_INTRO: string = "continueButtonStartFSSFS";
    public static CONTINUE_BUTTON_BONUS_END: string = "fsSFSOutroContinueButton";
    public static SCATTER_LANDED_1: string = "scatter1";
    public static SCATTER_LANDED_2: string = "scatter2";
    public static SCATTER_LANDED_3: string = "scatter3";
    public static SCATTER_LANDED_4: string = "scatter4";
    public static SCATTER_LANDED_5: string = "scatter5";
    public static PRE_BIG_WIN: string = "preBigWin";
    public static PRE_BIGWIN_ANTICIPATION: string = "preBigWinAnticipation";
    public static SPIN_COUNT_PLUS_1: string = "spinCount";
    public static BIG_WIN_MUSIC: string[] = ["bigWinLevel1", "bigWinLevel2", "bigWinLevel3", "bigWinLevel4", "bigWinLevel5"];
    public static BIG_WIN_LEVEL_CHANGE: string = "bigWinLevelTransition";
    public static BIG_WIN_END: string = "bigWinEnd";
    public static BOOSTED_BET_ON: string = "xBetOn";
    public static BOOSTED_BET_OFF: string = "xBetOff";
    public static BOTTLE_FILL: string[] = ["bottleFill1", "bottleFill2"];
    public static BONUS_INITIAL_IMPACT: string = "fsSfsInitialImpact";
    public static FS_INTRO_TEXT_SOUND: string = "fsIntroText";
    public static MULTIPLIER_ACTIVATE: string = "multiplierActivate";
    public static MULTIPLIER_UPDATE: string = "multiplierUpdate";
    public static BONUS_GAME_MULTIPLIER_AMOUNT: string = "multiplierUpdateReelsFSSFS";
    public static SCATTER_SOUND_IN_FS: string = "scatterFS";
    public static BONUS_GAME_FINAL_SCATTER_TO_LEVEL_UP: string = "scatterFSSFSFinalBottleFill";
    public static SOFT_WIN_CAP_PICK_CLICK: string = "winCapPickClickLoop";
    public static SOFT_WIN_CAP_DOOR_SCENE: string = "winCapDoorScene";
    public static WIN_CAP_LEVEL_1: string = "winCapLevel1";
    public static WIN_CAP_LEVEL_2: string = "winCapLevel2";
    public static WIN_CAP_LEVEL_3: string = "winCapLevel3";
    public static WIN_CAP_LEVEL_4: string = "winCapLevel4";
    public static WIN_CAP_LEVEL_5: string = "winCapLevel5";
    public static WIN_CAP_LEVEL_6: string = "winCapLevel6";
    public static WIN_CAP_FISH_DYING: string = "winCapFishDyingScene";
    public static WIN_CAP_FLUSH: string = "winCapToiletScene";
    public static WIN_CAP_TOAST: string = "winCapClickOnBottle";
    public static WIN_CAP_HOVER_LOOP: string = "winCapHoverLoop";
    public static BONUS_GAME_LEVEL_CHANGE_DRINK: string = "levelChangeDrinker";
    public static BONUS_GAME_SPIN_COUNT_2: string = "levelChangePlusSpins";
    public static BONUS_GAME_EXPANDING_DOWN: string = "pinkFrameCurtainDown";
    public static BONUS_GAME_EXPANDING_UP: string = "pinkFrameCurtainUp";
    public static BONUS_GAME_EXPANDING_SYMBOL_REEL1: string[] = ["characterFuckYou1", "characterFreddieAss1", "characterPimpMoney1", "characterProstitute1", "characterClown1"];
    public static BONUS_GAME_EXPANDING_SYMBOL_REEL2: string[] = ["characterFuckYou2", "characterFreddieAss2", "characterPimpMoney2", "characterProstitute2", "characterClown1"];
    public static BONUS_GAME_EXPANDING_SYMBOL_REEL3: string[] = ["characterFuckYou1", "characterFreddieAss1", "characterPimpMoney3", "characterProstitute3", "characterClown1"];
    public static XSPLIT_LANDING: string = "xSplitLand";
    public static XSPLIT_SPLITTING: string = "xSplitSplitting";
    public static XSPLIT_SPLITTING_ITSELF: string = "xSplitSplittingItself";
    public static FS_INTRO_VOICE: string = "fsIntroOneShot";
    public static SFS_INTRO_VOICE: string = "sfsIntroOneShot";
    public static SFS_WILD_GLITCH: string[] = ["vhsGlitch1", "vhsGlitch2"];
    public static ANTICIPATION_SOUND: string = "anticipation";
    public static ANTICIPATION_END_SOUND: string = "anticipationEnd";
    public static ANTICIPATION_REEL_STOP_SOUND: string = "anticipationReelStop";
    public static ANTICIPATION_BONUS_MODE_SOUND: string = "anticipationFSSFS";
    public static ANTICIPATION_BONUS_MODE_END_SOUND: string = "anticipationEndFSSFS";
    public static WINCAP_END_CONTINUE_SOUND: string = "winCapEndContinueButton";
    public static WINCAP_END_CONTINUE_LEVEL3_SOUND: string = "winCapEndContinueButtonLevel3";
    public static WINCAP_END_CONTINUE_LEVEL4_SOUND: string = "winCapEndContinueButtonLevel4";
    public static WINCAP_END_CONTINUE_LEVEL5_SOUND: string = "winCapEndContinueButtonLevel5";
    public static BONUS_OUTRO_HEART_BEAT_HIGH: string = "fsOutroHeartBeatsHigh";
    public static BONUS_OUTRO_HEART_BEAT_MID: string = "fsOutroHeartBeatsMid";
    public static BONUS_OUTRO_HEART_BEAT_LOW: string = "fsOutroHeartBeatsLow";
    public static CHARACTER_INTRO: string = "gameIntro";

    private static _currentMusic: string;

    constructor() {
    }

    public static get soundPlayer(): NolimitAudioPlayer {
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    public static switchMusic(conf: IPlayTrackConf, fadeInConf?: IFadeTrackConf, fadeOutConf?: IFadeTrackConf): void {
        if (conf.name === RockBottomSound._currentMusic) {
            return;
        }
        Logger.logDev(RockBottomSound._currentMusic, " sound switched to ", conf);
        if (RockBottomSound._currentMusic != null) {
            if (fadeOutConf) {
                fadeOutConf.name = this._currentMusic;
                const fade = RockBottomSound.soundPlayer.fadeTrack(fadeOutConf);
                const fadeName = this._currentMusic;
                if (fade) {
                    gsap.to(this, {
                        duration: fadeOutConf.duration / 1000,
                        onComplete: () => {
                            RockBottomSound.soundPlayer.stopTrack(fadeName);
                        }
                    });
                } else {
                    RockBottomSound.soundPlayer.stopTrack(fadeName);
                }
            } else {
                RockBottomSound.soundPlayer.stopTrack(RockBottomSound._currentMusic);
            }
        }

        RockBottomSound.soundPlayer.playTrack(conf);
        if (fadeInConf) {
            RockBottomSound.soundPlayer.fadeTrack(fadeInConf);
        }
        RockBottomSound._currentMusic = conf.name;
    }

    // Use this to handle the music, eg, fade out/in music in big win, and you don't need to care what music is playing
    public static fadeMusic(vol: number, duration: number): void {
        RockBottomSound.soundPlayer.fadeTrack({
            name: RockBottomSound._currentMusic,
            to: vol,
            duration: duration
        });
        Logger.logDev("fading soundTrack: ", RockBottomSound._currentMusic, " vol ", vol);
    }

    public static getMusicNameByMode(mode: RockBottomGameMode | string): string {
        switch (mode) {
            case RockBottomGameMode.FREESPIN:
                return RockBottomSound.FREESPIN_INTRO_MUSIC;
            case RockBottomGameMode.SUPER_FREESPIN:
                return RockBottomSound.SUPER_FREESPIN_INTRO_MUSIC;
            case RockBottomGameMode.NORMAL:
                return RockBottomSound.MAIN_GAME_MUSIC;
            default:
                return RockBottomSound.MAIN_GAME_MUSIC;
        }
    }

    public static playTrack(soundName: string, vol?: number): NolimitHowl | undefined {
        Logger.logDev("sound playTrack: ", soundName, " vol ", vol);
        return RockBottomSound.soundPlayer.playTrack({name: soundName, volume: vol});
    }

    public static fadeAndStopSound(fadeOutConf: IFadeTrackConf): void {
        const fade = RockBottomSound.soundPlayer.fadeTrack(fadeOutConf);
        if (fade) {
            gsap.to(this, {
                duration: fadeOutConf.duration / 1000,
                onComplete: () => {
                    RockBottomSound.soundPlayer.stopTrack(fadeOutConf.name);
                }
            });
        } else {
            RockBottomSound.soundPlayer.stopTrack(fadeOutConf.name);
        }
    }
}